import { IndexValue } from '../../../types/IndexValue';
import { GenericInput } from './GenericInput';
import { GenericInputProps } from './GenericInputProps';
const EMAIL_PATTERN: RegExp = /[^@\s]+@[^@\s]+/;

export function InputEmail<T extends IndexValue>(props: GenericInputProps<T>) {
  return (
    <GenericInput
      required={props.required}
      placeholder={props.placeholder}
      name={props.name}
      type="text"
      disabled={props.disabled}
      tooltip={props.tooltip}
      label={props.label}
      children={props.children}
      formRegister={props.formRegister}
      maxLength={props.maxLength}
      minLength={props.minLength}
      pattern={EMAIL_PATTERN}
      validateFunction={props.validateFunction}
      errorCollection={props.errorCollection}
    />
  );
}
